import { useEffect, useRef } from 'react';
import { useVerticalSystemContext } from '../VerticalSystemContext/VerticalSystemContext';
import { VerticalSystemTabItem } from '../types';

const duration = 601;

export function useVerticalSystemAccordionAnimation() {
  const { activeTabItem, activeVariant } = useVerticalSystemContext();
  const heights = useRef<number[]>([]);

  useEffect(() => {
    const tabPanel = getTabPanelByTabItem(activeTabItem);
    const currentList = getLists(tabPanel);
    const currentHeights = getListHeights(tabPanel);

    currentList.forEach((li, index) => {
      animate(li, heights.current.at(index), currentHeights.at(index));
    });
  }, [activeTabItem]);

  useEffect(() => {
    const intervalId = setInterval(setHeight, 33);
    const timeoutId = setTimeout(() => clearInterval(intervalId), duration);

    function setHeight() {
      const tabPanel = getTabPanelByTabItem(activeTabItem);
      const listHeights = getListHeights(tabPanel);
      if (listHeights.some(h => !h)) return;
      heights.current = listHeights;
    }

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [activeVariant, activeTabItem]);
}

function getTabPanelByTabItem(tabItem?: VerticalSystemTabItem) {
  return document.getElementById(`panel-${tabItem?.id}`);
}

function getLists(list: HTMLElement | null) {
  return Array.from(list?.querySelectorAll('li') ?? []);
}

function getListHeights(list: HTMLElement | null) {
  return getLists(list).map(li => Math.round(li.getBoundingClientRect().height));
}

function animate(el: HTMLElement, prev?: number, next?: number) {
  if (!prev || !next || prev === next) return;

  el.style.setProperty('height', `${prev}px`);
  setTimeout(() => {
    el.style.setProperty('height', `${next}px`);
    el.style.setProperty('transition-name', 'height');

    setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('transition-name');
    }, duration);
  });
}
